import type { Meta, StoryObj } from '@storybook/react';

import { BloomFlower } from './BloomFlower';
import { GRADIENTS } from '../../../config/designSystem/Colors';

// same color wiring as the assessment frame (PresentAssessment)
const gradient = GRADIENTS.modules.LAVENDER;

const meta = {
  title: 'Diary/BloomFlower',
  component: BloomFlower,
  args: {
    bloom: 0.5,
    size: 220,
    petalColor: gradient.base.right,
    rayColor: gradient.dark.left,
  },
} satisfies Meta<typeof BloomFlower>;

export default meta;

type Story = StoryObj<typeof meta>;

export const HalfBloom: Story = {};

export const Closed: Story = {
  args: { bloom: 0 },
};

export const FullBloom: Story = {
  args: { bloom: 1 },
};
